import { AfterViewInit, Component, EventEmitter, Output, OnInit, ViewChild, ElementRef } from "@angular/core";
import { FormBuilder, FormControl, FormGroup, Validators } from "@angular/forms";
import { apiService } from "app/services/api.service";
import { DomSanitizer, SafeResourceUrl } from "@angular/platform-browser";
import { globalData } from "../../../services/globalData.service";

@Component({
  selector: 'app-login-form',
  templateUrl: './login-form.component.html',
  styleUrls: ['./login-form.component.scss']
})
export class LoginFormComponent implements OnInit {

  @Output() childButtonEventLogin = new EventEmitter();
  @Output() childButtonEventReset = new EventEmitter();
  @Output() clickHandlerSuccessful: EventEmitter<number> = new EventEmitter<number>();
  @Output() countryCodeSelected: EventEmitter<string> = new EventEmitter<string>();
  @Output() closeModal: EventEmitter<void> = new EventEmitter<void>();

  myForm: FormGroup;
  countryCodes: any[] = [];

  isOpen: boolean = false;
  selectedCountryCode: string = ''; // Default selected country code

  isAppleEnable: boolean = false;
  appleLoginUri: string = '#';
  isGoogleEnable: boolean = false;
  googleLoginUri: string = '#';
  isTwitterEnable: boolean = false;
  twitterLoginUri: string = '#';
  isInstagramEnable: boolean = false;
  instagramLoginUri: string = '#';
  isFacebookEnable: boolean = false;
  facebookLoginUri: string = '#';
  openIfram: boolean = false;
  iframeUrl: SafeResourceUrl;
  mobileNoMaxLength: number = 10;
  siteKey: any;
  captchaValue: string;
  isOTPSend = false;
  enterOTP = false;
  keyword: string = "";
  isCountrySelected: boolean = false;
  errorMessage: string = '';
  isLoginForm: boolean = true;
  loginOTP: string = '';
  IsVerifyOTP: boolean = true;
  otpSentOnText: string = '';
  otpSentText: string = '';
  isUserLogin: boolean = false;
  loginUserName: any = '';
  loginUserId: any = '';
  loginUserToken: any = '';
  mobileNo_Or_Email: string = '';
  loginSuccessful: boolean = false;
  showLoginSuccessMessage: boolean = false;
  submitted: boolean = false;

  @ViewChild('inputA') inputA: ElementRef;
  @ViewChild('inputB') inputB: ElementRef;
  @ViewChild('inputC') inputC: ElementRef;
  @ViewChild('inputD') inputD: ElementRef;
  @ViewChild('inputE') inputE: ElementRef;
  @ViewChild('inputF') inputF: ElementRef;
  @ViewChild("input", { static: false }) input: ElementRef;
  errorMessageCaptch: string;
  errorMessagePassword: string;
  constructor(private _apiService: apiService, public sanitizer: DomSanitizer, public global: globalData) { }

  ngOnInit() {
    this.myForm = new FormGroup({
      mobile: new FormControl('', Validators.required),
      email: new FormControl('', Validators.email),
      password: new FormControl('', Validators.required),
      captcha: new FormControl('', Validators.required),
      searchText: new FormControl('')
    });

    this.generateCaptcha();
    this.isOpen = false;

    this.countryCodes = [];
    this.GetCountryList();
    this._apiService.getGeneral()
      .subscribe(
        data => {
          console.log('general data', data.data);
          let generalData = data.data;
          let languageCode = localStorage.getItem('languageCode');
          let languageParam = '?language_code=' + languageCode;
          if (generalData?.apple?.enable) {
            this.isAppleEnable = true;
            this.appleLoginUri = generalData?.apple?.loginUrl + languageParam;
          }
          if (generalData?.google?.enable) {
            this.isGoogleEnable = true;
            this.googleLoginUri = generalData?.google?.loginUrl + languageParam;
          }
          if (generalData?.twitter?.enable) {
            this.isTwitterEnable = true;
            this.twitterLoginUri = generalData?.twitter?.loginUrl + languageParam;
          }
          if (generalData?.instagram?.enable) {
            this.isInstagramEnable = true;
            this.instagramLoginUri = generalData?.instagram?.loginUrl + languageParam;
          }
          if (generalData?.facebook?.enable) {
            this.isFacebookEnable = true;
            this.facebookLoginUri = generalData?.facebook?.loginUrl + languageParam;
          }
        }
      )
  }

  search() {
    this.errorMessage = "";
    this.GetCountryList();
  }

  GetCountryList() {

    var searchText = this.myForm.value.searchText;

    this.global.GetCountryList(searchText).then((countryCodes: any[]) => {
      this.countryCodes = countryCodes;

      if (!this.isCountrySelected && this.countryCodes.length > 0) {

        var country = this.countryCodes.find(item => item.iso_code === this.global.customerCountryCode);
        if (country) {
          this.selectedCountryCode = country.isd_code;
          this.mobileNoMaxLength = country.mobNo_length;
        }
        else {
          this.selectedCountryCode = this.countryCodes[0].isd_code;
          this.mobileNoMaxLength = this.countryCodes[0].mobNo_length;
        }
      }
    });
  }

  generateCaptcha() {
    // Logic to generate a random captcha value
    // For simplicity, let's use a 4-digit number as the captcha
    this.captchaValue = Math.floor(1000 + Math.random() * 9000).toString();
  }

  regenerateCaptcha() {
    this.myForm.get('captcha')?.setValue('');
    this.generateCaptcha();
  }

  clickHandler() {
    this.childButtonEventLogin.emit(2);
  }

  clickHandlerReset() {
    this.childButtonEventReset.emit(3);
  }

  emitClickHandlerSuccessful() {
    this.clickHandlerSuccessful.emit(4);
  }

  toggleDropdown(event: Event) {
    event.stopPropagation(); // Prevent the click event from reaching parent elements
    this.isOpen = this.isOpen ? false : true;
  }

  closeDropDown(event: Event) {
    event.stopPropagation();
    this.isOpen = false;
  }

  countryCodeSelect(code: any, event: Event) {
    this.errorMessage = "";
    this.isOpen = false; // Close the dropdown when an option is selected
    this.mobileNoMaxLength = code.mobNo_length;
    this.myForm.get('searchText')?.setValue('');
    this.isCountrySelected = true;
    this.GetCountryList();
    this.selectedCountryCode = code.isd_code;
    this.mobileNoMaxLength = code.mobNo_length;
    this.countryCodeSelected.emit(this.selectedCountryCode); // Emit the selected country code if needed
  }

  isPasswordVisible: boolean = false;

  togglePasswordVisibility() {
    this.isPasswordVisible = !this.isPasswordVisible;
  }

  isMobileNumberTabActive: boolean = true;
  isEmailTabActive: boolean = false;

  showMobileNumberTab() {
    this.isMobileNumberTabActive = true;
    this.errorMessage = "";
    this.isEmailTabActive = false;
    this.myForm.get('mobile')?.setValidators([Validators.required])
    this.myForm.get('mobile')?.updateValueAndValidity();

    this.myForm.get('email')?.clearValidators();
    this.myForm.get('email')?.updateValueAndValidity();
  }

  showEmailTab() {
    this.isMobileNumberTabActive = false;
    this.errorMessage = "";
    this.isEmailTabActive = true;

    this.myForm.get('email')?.setValidators([Validators.required])
    this.myForm.get('email')?.updateValueAndValidity();

    this.myForm.get('mobile')?.clearValidators();
    this.myForm.get('mobile')?.updateValueAndValidity();
  }

  loadIframe(url: string) {
    /*this.openIfram = true;
    this.iframeUrl = this.sanitizer.bypassSecurityTrustResourceUrl(url);*/
    var win = window.open(url, '_self');
    console.log(url);
    win?.document.write('<iframe width="100%" height="100%" src=' + url + ' frameborder="10"></iframe>')
  }

  onInputChange(inputElement: any): void {
    const inputValue = inputElement.value;
    const maxLength = inputElement.maxLength;

    if (inputValue.length === maxLength) {
      // Focus on the next input element
      const nextInput = inputElement.nextElementSibling;
      if (nextInput instanceof HTMLInputElement) {
        nextInput.focus();
      }
    }
  }

  sendVerificationOTP() {
    this.isOTPSend = true;
    this.enterOTP = false;

    const headers = { "Content-Type": "application/json" };

    const paramSendOTP = {
      "type": this.isMobileNumberTabActive ? 'mobile' : 'email',
      "isd_code": this.selectedCountryCode,
      "mobile_or_email": this.mobileNo_Or_Email,
      "language_code": localStorage.getItem('languageCode')
    }

    this._apiService.sendVerificationOTP(paramSendOTP, headers).subscribe(resp => {
      if (resp.success == true) {
        this.isOTPSend = false;
        this.enterOTP = true;
        this.loginOTP = String(resp.data[0].otp);
        this.IsVerifyOTP = resp.data[0].otp_verify;

        let otpDigits: string[] = [];

        for (let i = 0; i < this.loginOTP.length; i++) {
          otpDigits.push(this.loginOTP[i]);
        }

        if (otpDigits.length > 0) {
          setTimeout(() => {
            if (!this.IsVerifyOTP) {
              this.inputA.nativeElement.value = otpDigits[0];
              this.inputB.nativeElement.value = otpDigits[1];
              this.inputC.nativeElement.value = otpDigits[2];
              this.inputD.nativeElement.value = otpDigits[3];
              this.inputE.nativeElement.value = otpDigits[4];
              this.inputF.nativeElement.value = otpDigits[5];
            }
          }, 200);
        }
      }
      else {
        alert("Error occur while sending OTP.")
      }
    });

  }

  customerLogin(form: FormGroup) {
    this.errorMessage = "";
    this.submitted = true;

    const headers = { "Content-Type": "application/json" };
    var value = this.isMobileNumberTabActive ? form.value.mobile : form.value.email;
    this.mobileNo_Or_Email = this.isMobileNumberTabActive ? form.value.mobile : form.value.email;
    if (form.valid && form.value.captcha === this.captchaValue && value) {
      const bodyParam = {
        "language_code": localStorage.getItem('languageCode'),
        "login_with": this.isMobileNumberTabActive ? 'mobile' : 'email',
        "isd_code": this.selectedCountryCode,
        "mobile_or_email": this.isMobileNumberTabActive ? form.value.mobile : form.value.email,
        "password": form.value.password
      };

      this._apiService.customerLogin(bodyParam, headers).subscribe(response => {
        if (response.success == true) {
          this.loginSuccessful = true;
          console.log('Login successful');
          let responseObj = response.data;
          this.showLoginSuccessMessage = true;
          this.loginUserName = responseObj[0].first_name ? responseObj[0].first_name : 'User';
          this.isUserLogin = true;
          this.loginUserId = responseObj[0].id;
          this.loginUserToken = responseObj[0].token;

          if (!responseObj[0].is_email_verified && !responseObj[0].is_mobile_verified) {
            this.isLoginForm = false;

            this.otpSentOnText = this.isMobileNumberTabActive ? this.selectedCountryCode + ' ' + form.value.mobile : form.value.email;
            this.otpSentText = this.isMobileNumberTabActive ? ' Mobile Number' : ' Email';

            this.sendVerificationOTP();
          }
          else {
            this.global.loginUserName = this.loginUserName;
            this.global.isUserLogin = this.isUserLogin;
            this.global.loginUserId = this.loginUserId;
            this.global.auth_token = this.loginUserToken;

            localStorage.setItem('loginUserName', this.loginUserName);
            localStorage.setItem('isUserLogin', String(this.isUserLogin));
            localStorage.setItem('loginUserId', this.loginUserId);
            localStorage.setItem('loginUserToken', this.loginUserToken);

            this.emitClickHandlerSuccessful();
          }
        }
        else {
          this.errorMessage = response.message;
        }
      });
    }
    else {
      if (!value) {
        this.errorMessage = this.isMobileNumberTabActive ? 'Please enter Mobile No.' : 'Please enter Email.';
        form.get('captcha')?.setValue('');
        this.regenerateCaptcha();
        return;
      }
      if (!form.value.password) {
        this.errorMessagePassword = 'Please Enter Password';
        form.get('captcha')?.setValue('');
        this.regenerateCaptcha();
        return;
      }
      const controls = form.controls;
      for (const name in controls) {
        if (controls[name].invalid) {
          this.errorMessageCaptch = name.toUpperCase() + ' is Invalid';
          form.get('captcha')?.setValue('');
          this.regenerateCaptcha();
          return;
        }
      }
      if (form.value.captcha != this.captchaValue) {
        this.errorMessageCaptch = "Captch is not matching";
        form.get('captcha')?.setValue('');
        this.regenerateCaptcha();
        return;
      }
    }
  }

  verifyOTP() {
    const headers = { "Content-Type": "application/json" };

    const OTP = this.inputA.nativeElement.value + this.inputB.nativeElement.value + this.inputC.nativeElement.value + this.inputD.nativeElement.value + this.inputE.nativeElement.value + this.inputF.nativeElement.value;
    const bodyParam = {
      "language_code": localStorage.getItem('languageCode'),
      "type": this.isMobileNumberTabActive ? 'mobile' : 'email',
      "isd_code": this.selectedCountryCode,
      "mobile_or_email": this.mobileNo_Or_Email,
      "otp": OTP
    };

    this._apiService.verifyOTP(bodyParam, headers).subscribe(resp => {
      if (resp.success == true) {
        this.loginUserName = resp.data.first_name ? resp.data.first_name : 'User';
        this.isUserLogin = true;
        this.loginUserId = resp.data.id;
        this.loginUserToken = resp.data.token;

        this.global.loginUserName = this.loginUserName;
        this.global.isUserLogin = this.isUserLogin;
        this.global.loginUserId = this.loginUserId;
        this.global.auth_token = this.loginUserToken;

        localStorage.setItem('loginUserName', this.loginUserName);
        localStorage.setItem('isUserLogin', String(this.isUserLogin));
        localStorage.setItem('loginUserId', this.loginUserId);
        localStorage.setItem('loginUserToken', this.loginUserToken);
        this.closeModal.emit();
      }
      else {
        this.closeModal.emit();
        alert(resp.message);
      }
    });
  }
}
function clickHandlerSucessful() {
  throw new Error("Function not implemented.");
}

